import { environment as defaultEnvironment } from './environment.defaults';
export const environment = {
  ...defaultEnvironment,
  production: false,
  apiPath: 'https://dgoldsoft-api.kpvsolutions.com/',
  apiDomain: 'dgoldsoft-api.kpvsolutions.com/'
};
